export { default as AddToDashboardMenu } from './AddToDashboardMenu';
export { default as Dashboard } from './Dashboard';
export { default as DashboardList } from './DashboardList';
export { default as DashboardListPage } from './DashboardListPage';
export { default as EditDashboardModal } from './EditDashboardModal';
export { default as EditDashboardModalTrigger } from './EditDashboardModalTrigger';



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/graylog-project-cli-release/.repos/graylog2-server/graylog2-web-interface/src/components/dashboard/index.jsx